import axios from "axios";
export const getLocaleSlug = () =>
  window.location.pathname.match(/^\/([^/]+)/)?.[1]?.toLowerCase() || "en-us";

export const axiosApiWrapper = axios.create();

axiosApiWrapper.interceptors.request.use((config) => {
  const tag = getLocaleSlug();

  config.headers = {
    ...config.headers,
    "accept-language": tag,
  };
  return config;
});
